<div class="g-page g-container oops-container">
  <div class="logo">
    <img
      class="logo-img"
      src="../../../assets/images/logo.png"
      alt="Klondike"
      loading="lazy"
    >
    <span class="logo-text">Клондайк - товари для творчості!</span>
  </div>

  <div class="oops-text">
    Упс... На сайті проводяться технічні роботи. Будь ласка, спробуйте знову
    @if (maintenanceService.maintenanceEndTime(); as endTime) { в <span class="time">{{ endTime | date:'HH:mm' : undefined : languageService.getCurrentLocale() }}</span> } @else { пізніше } 🙂

  </div>

  <img
    class="maintenance-img"
    src="../../../assets/images/website-maintenance-img.jpeg"
    alt="технічні роботи"
  >
</div>
